"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridColumnMovingPlugin = void 0;
const react_1 = __importDefault(require("react"));
const ColumnMovingCell_1 = require("./components/ColumnMovingCell/ColumnMovingCell");
const ColumnMovingIndicator_1 = require("./components/ColumnMovingIndicator/ColumnMovingIndicator");
function gridColumnMovingPlugin(config) {
    return ({ rootRef, bodyRef, getColumns }) => {
        function calculateColumnsOrder({ prevIndex, nextIndex }) {
            const isForwardDirection = prevIndex < nextIndex;
            return getColumns()
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .reduce((acc, curr, idx) => {
                const currIndex = idx;
                if (prevIndex === currIndex) {
                    acc[curr.id] = nextIndex;
                    return acc;
                }
                if (currIndex === nextIndex) {
                    acc[curr.id] = currIndex + (isForwardDirection ? -1 : 1);
                    return acc;
                }
                if (isForwardDirection && currIndex > prevIndex && currIndex < nextIndex) {
                    acc[curr.id] = currIndex - 1;
                    return acc;
                }
                if (!isForwardDirection && currIndex > nextIndex && currIndex < prevIndex) {
                    acc[curr.id] = currIndex + 1;
                    return acc;
                }
                acc[curr.id] = currIndex;
                return acc;
            }, {});
        }
        return {
            processColumns: (originalColumns) => {
                return originalColumns.map((column) => {
                    if (column.isService) {
                        return Object.assign({}, column);
                    }
                    return Object.assign(Object.assign({}, column), { header: (props) => {
                            return (react_1.default.createElement(ColumnMovingCell_1.ColumnMovingCell, { rootRef: rootRef, bodyRef: bodyRef, key: `col-${props.column.id}`, columnsGetter: () => getColumns().map((i) => ({
                                    width: i.width || 0,
                                    isService: !!i.isService
                                })), content: column.header(Object.assign({}, props)), onColumnOrderChange: ({ prevColumnIndex, nextColumnIndex }) => {
                                    config.onChange({
                                        prevIndex: prevColumnIndex,
                                        nextIndex: nextColumnIndex,
                                        orders: calculateColumnsOrder({
                                            prevIndex: prevColumnIndex,
                                            nextIndex: nextColumnIndex
                                        })
                                    });
                                } }));
                        } });
                });
            },
            containerAddons: [
                {
                    id: 'columnMovingIndicator',
                    order: 99,
                    render: () => react_1.default.createElement(ColumnMovingIndicator_1.ColumnMovingIndicator, null)
                }
            ]
        };
    };
}
exports.gridColumnMovingPlugin = gridColumnMovingPlugin;
//# sourceMappingURL=gridColumnMovingPlugin.js.map